var map = {
	"./blogposts": 12,
	"./blogposts.js": 12,
	"./book_images/AtlasShrugged.png": 70,
	"./book_images/BarbarianDays.jpg": 71,
	"./book_images/DoubleHelix.png": 72,
	"./book_images/EnlightenmentNow.png": 73,
	"./book_images/Genome.png": 74,
	"./book_images/GodsDebris.png": 75,
	"./book_images/HowToChangeYourMind.png": 76,
	"./book_images/SixEasyPieces.png": 77,
	"./book_images/WakingUp.png": 78,
	"./book_images/sapiens.png": 79,
	"./books": 48,
	"./books.js": 48,
	"./essay_images/ClosedSystems.jpeg": 80,
	"./essay_images/bioluminescence.jpg": 81,
	"./essay_images/fish_and_scales.jpg": 38,
	"./essay_images/supply-demand-equilibrium.png": 82,
	"./essay_images/supply-demand-goods.png": 83,
	"./essay_images/supply-demand-money.png": 84,
	"./hubble.jpg": 85,
	"./project_images": 20,
	"./project_images/": 20,
	"./project_images/ParkingEmail.png": 21,
	"./project_images/Project_Website.png": 30,
	"./project_images/SpiffyHomepage.png": 22,
	"./project_images/SpiffyPortraitEdit.png": 23,
	"./project_images/SpiffyShareLink.png": 24,
	"./project_images/SpiffyUserHome.png": 25,
	"./project_images/TriangleParkingHomepage.png": 26,
	"./project_images/WormViz_1.png": 39,
	"./project_images/WormViz_2.png": 40,
	"./project_images/electrode_placement.jpeg": 41,
	"./project_images/index": 20,
	"./project_images/index.js": 20,
	"./project_images/model_diagram.png": 42,
	"./project_images/seizure_predictions.png": 43,
	"./project_images/signaling_channel_phenotypes.png": 44,
	"./project_images/triangleparkingwebsite.png": 27,
	"./projects": 31,
	"./projects.js": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;